import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FieldValues } from 'react-hook-form';
import useCheckoutDeviceApi from '../../project/useCheckoutDevicesApi';
import ResourceFormView from '../../apiForm/scaffold/ResourceFormView';
import { DynaForm, UISchemaScope } from '../../dynaForm';

export default function DynaConfigView() {
  const { t } = useTranslation();
  const api = useCheckoutDeviceApi();

  const [uiSchema, setUiSchema] = useState<any>(null);
  const [etag, setEtag] = useState<string>('');

  const handleFetchAppearance = useCallback(async () => {
    const { data, etag: responseEtag } = await api.getAppearanceConfig(null);
    setEtag(responseEtag);
    setUiSchema(await api.getUiSchema(null));
    return data;
  }, [api]);

  const handleSubmitAppearance = useCallback(
    async (data: FieldValues) => {
      await api.updateAppearanceConfig({ data, etag });
      const { etag: responseEtag } = await api.getAppearanceConfig(null);
      setEtag(responseEtag);
    },
    [api, etag],
  );

  return (
    <ResourceFormView
      actionName="updateDynaConfig"
      headline={t('headlines.dynaConfig')}
      Form={DynaForm as any}
      FormProps={{
        uiSchema,
        currentScope: UISchemaScope.ADMIN,
      }}
      fetch={handleFetchAppearance}
      submit={handleSubmitAppearance}
    />
  );
}
